import { NgModule } from '@angular/core';
import { BrowserModule, DOCUMENT } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';

import { SystemPaths } from '../shared/system-paths';
import { AuthUtils } from '../shared/authutils';
import { SystemUtils } from '../shared/systemutils';
import { CookieUtils } from '../shared/cookieutils';

import { Modal, ModalAction, ModalResult } from './modal.component';
import { CommonModalsComponent } from './common-modals.component';
import { LeagueHeaderComponent } from './league-header.component';
import { MapToIterablePipe } from './map-to-iterable.pipe';

import { GetGameSummariesForSeasonService } from '../service/get-game-summaries-for-season.service';

@NgModule({
  declarations: [
    CommonModalsComponent,
    LeagueHeaderComponent,
    Modal,
    MapToIterablePipe
  ],
  imports: [
    BrowserModule,
    HttpModule
  ],
  providers: [
    SystemPaths, AuthUtils, SystemUtils, CookieUtils,
    Modal, MapToIterablePipe,
    GetGameSummariesForSeasonService
  ],
  exports: [
    CommonModalsComponent,
    LeagueHeaderComponent,
    Modal,
    MapToIterablePipe
  ]
})
export class SharedComponentModule { }
